import React from 'react';
import './App.css';
import PopUpHandler from "./support/pop_up";
import RootNavigator from "./support/navigation";
function App() {
    return (
        <PopUpHandler>
            <RootNavigator />
        </PopUpHandler>
    );
}

export default App;
